import { diContainer } from "@/di";
import { IDownloadHandler } from "./handlers/DownloadHandler";
import PDFDownloadHandler from "./handlers/PDFDownloadHandler";
import ZIPDownloadHandler from "./handlers/ZIPDownloadHandler";
import { MimeTypes } from "./types";
import { injectable } from "inversify";
import "reflect-metadata";
import PNGDownloadHandler from "./handlers/PNGDownloadHandler";
import PFXDownloadHandler from "./handlers/PFXDownloadHandler";

@injectable()
export default class DownloadStrategy {
  private downloadHandler: IDownloadHandler =
    diContainer.get(PDFDownloadHandler);

  constructor() {
    const zipHandler = diContainer.get(ZIPDownloadHandler);

    this.downloadHandler
      .setNext(zipHandler)
      .setNext(diContainer.get(PNGDownloadHandler))
      .setNext(diContainer.get(PFXDownloadHandler));
  }

  download(mimeType: MimeTypes) {
    return this.downloadHandler.handle(mimeType);
  }
}
